// Theme: midnight-city-ultra
// Auto-generated by scripts/materialize-theme-presets.ts
// Source of truth for theme configuration

import type { ThemePreset } from '@/lib/themes/types'

export const THEME_PRESET: ThemePreset = {
  id: 'midnight-city-ultra',
  name: 'MIDNIGHT CITY ULTRA',
  tagline: 'MIDNIGHT CITY ULTRA',
  description: 'Recolor frio do midnight city mantendo estrutura epica base.',
  category: 'urban-expression',
  tier: 'epic',
  basePrice: 3675,
  swatches: ['#0B0F1D', '#60A5FA', '#151F38', '#D6EAFF'],
  familyId: 'midnight-city',
  variantName: 'ULTRA',
  baseStyle: {
    cardClasses: '',
    shapeVars: {
      '--border-w': '1px',
      '--radius': '12px',
      '--shadow-card': '0 12px 28px rgba(0, 0, 0, 0.22)',
      '--shadow-card-active': '0 0 24px color-mix(in srgb, var(--primary) 10%, transparent)'
    },
    shellClasses: 'font-sans theme-midnight-city-ultra'
  },
  colorVars: {
    '--accent': '#60A5FA',
    '--accent-foreground': '#0B0F1D',
    '--background': '#0B0F1D',
    '--border': '#2A3A6A',
    '--card': '#151F38',
    '--card-border-active': 'rgba(96, 165, 250, 0.48)',
    '--card-completed': '#151F38',
    '--card-foreground': '#D6EAFF',
    '--card-glow': 'rgba(96, 165, 250, 0.1)',
    '--coin': 'var(--rarity-legendary)',
    '--destructive': '#EF4444',
    '--destructive-foreground': '#0B0F1D',
    '--foreground': '#D6EAFF',
    '--hold-fill': '#60A5FA',
    '--input': '#151F38',
    '--modal-bg': '#0B0F1D',
    '--modal-border': '#2A3A6A',
    '--modal-overlay-bg': 'rgba(0, 0, 0, 0.75)',
    '--modal-shadow': '0 12px 28px rgba(0, 0, 0, 0.22)',
    '--muted': '#2A3A6A',
    '--muted-foreground': '#D6EAFF',
    '--nav-active': '#60A5FA',
    '--nav-bg': '#0B0F1D',
    '--popover': '#151F38',
    '--popover-foreground': '#D6EAFF',
    '--primary': '#60A5FA',
    '--primary-foreground': '#0B0F1D',
    '--ring': '#60A5FA',
    '--secondary': '#2A3A6A',
    '--secondary-foreground': '#D6EAFF',
    '--streak': '#60A5FA',
    '--success': '#22C55E',
    '--success-foreground': '#0B0F1D',
    '--xp': '#60A5FA',
    '--xp-bg': '#151F38'
  },
  resolvedVars: {
    '--accent': '#60A5FA',
    '--accent-foreground': '#0B0F1D',
    '--accent-foreground-hsl': '227 45% 8%',
    '--accent-foreground-oklch': 'from #0B0F1D l c h',
    '--accent-hsl': '213 94% 68%',
    '--accent-oklch': 'from #60A5FA l c h',
    '--background': '#0B0F1D',
    '--background-hsl': '227 45% 8%',
    '--background-oklch': 'from #0B0F1D l c h',
    '--border': '#2A3A6A',
    '--border-hsl': '225 43% 29%',
    '--border-oklch': 'from #2A3A6A l c h',
    '--border-w': '1px',
    '--card': '#151F38',
    '--card-border-active': 'rgba(96, 165, 250, 0.48)',
    '--card-completed': '#151F38',
    '--card-completed-hsl': '223 45% 15%',
    '--card-completed-oklch': 'from #151F38 l c h',
    '--card-foreground': '#D6EAFF',
    '--card-foreground-hsl': '211 100% 92%',
    '--card-foreground-oklch': 'from #D6EAFF l c h',
    '--card-glow': 'rgba(96, 165, 250, 0.1)',
    '--card-hsl': '223 45% 15%',
    '--card-oklch': 'from #151F38 l c h',
    '--coin': 'var(--rarity-legendary)',
    '--destructive': '#EF4444',
    '--destructive-foreground': '#0B0F1D',
    '--destructive-foreground-hsl': '227 45% 8%',
    '--destructive-foreground-oklch': 'from #0B0F1D l c h',
    '--destructive-hsl': '0 84% 60%',
    '--destructive-oklch': 'from #EF4444 l c h',
    '--foreground': '#D6EAFF',
    '--foreground-hsl': '211 100% 92%',
    '--foreground-oklch': 'from #D6EAFF l c h',
    '--hold-fill': '#60A5FA',
    '--hold-fill-hsl': '213 94% 68%',
    '--hold-fill-oklch': 'from #60A5FA l c h',
    '--input': '#151F38',
    '--input-hsl': '223 45% 15%',
    '--input-oklch': 'from #151F38 l c h',
    '--modal-bg': '#0B0F1D',
    '--modal-bg-hsl': '227 45% 8%',
    '--modal-bg-oklch': 'from #0B0F1D l c h',
    '--modal-border': '#2A3A6A',
    '--modal-border-hsl': '225 43% 29%',
    '--modal-border-oklch': 'from #2A3A6A l c h',
    '--modal-overlay-bg': 'rgba(0, 0, 0, 0.75)',
    '--modal-shadow': '0 12px 28px rgba(0, 0, 0, 0.22)',
    '--muted': '#2A3A6A',
    '--muted-foreground': '#D6EAFF',
    '--muted-foreground-hsl': '211 100% 92%',
    '--muted-foreground-oklch': 'from #D6EAFF l c h',
    '--muted-hsl': '225 43% 29%',
    '--muted-oklch': 'from #2A3A6A l c h',
    '--nav-active': '#60A5FA',
    '--nav-active-hsl': '213 94% 68%',
    '--nav-active-oklch': 'from #60A5FA l c h',
    '--nav-bg': '#0B0F1D',
    '--nav-bg-hsl': '227 45% 8%',
    '--nav-bg-oklch': 'from #0B0F1D l c h',
    '--popover': '#151F38',
    '--popover-foreground': '#D6EAFF',
    '--popover-foreground-hsl': '211 100% 92%',
    '--popover-foreground-oklch': 'from #D6EAFF l c h',
    '--popover-hsl': '223 45% 15%',
    '--popover-oklch': 'from #151F38 l c h',
    '--primary': '#60A5FA',
    '--primary-foreground': '#0B0F1D',
    '--primary-foreground-hsl': '227 45% 8%',
    '--primary-foreground-oklch': 'from #0B0F1D l c h',
    '--primary-hsl': '213 94% 68%',
    '--primary-oklch': 'from #60A5FA l c h',
    '--radius': '12px',
    '--ring': '#60A5FA',
    '--ring-hsl': '213 94% 68%',
    '--ring-oklch': 'from #60A5FA l c h',
    '--secondary': '#2A3A6A',
    '--secondary-foreground': '#D6EAFF',
    '--secondary-foreground-hsl': '211 100% 92%',
    '--secondary-foreground-oklch': 'from #D6EAFF l c h',
    '--secondary-hsl': '225 43% 29%',
    '--secondary-oklch': 'from #2A3A6A l c h',
    '--shadow-card': '0 12px 28px rgba(0, 0, 0, 0.22)',
    '--shadow-card-active': '0 0 24px color-mix(in srgb, var(--primary) 10%, transparent)',
    '--streak': '#60A5FA',
    '--streak-hsl': '213 94% 68%',
    '--streak-oklch': 'from #60A5FA l c h',
    '--success': '#22C55E',
    '--success-foreground': '#0B0F1D',
    '--success-foreground-hsl': '227 45% 8%',
    '--success-foreground-oklch': 'from #0B0F1D l c h',
    '--success-hsl': '142 71% 45%',
    '--success-oklch': 'from #22C55E l c h',
    '--tint-primary-subtle': 'hsla(213 94% 68% / 0.15)',
    '--xp': '#60A5FA',
    '--xp-bg': '#151F38',
    '--xp-bg-hsl': '223 45% 15%',
    '--xp-bg-oklch': 'from #151F38 l c h',
    '--xp-hsl': '213 94% 68%',
    '--xp-oklch': 'from #60A5FA l c h'
  }
}
